// This file is generated.
export var version = '1.81.0';
//# sourceMappingURL=version.js.map